module.exports = __webpack_public_path__ + "img/feature-6.89ca2027.jpg";